export default __webpack_public_path__ + "static/media/fresh_veg_mob.b7e57539.webp";